import ErrorIndicator from './error-indicator';

export default ErrorIndicator;



// WEBPACK FOOTER //
// ./src/components/error-indicator/index.js